import { Navigate, Outlet, useLocation, useParams } from 'react-router';
import { PageRequireAuth } from '@/ui/components/require-auth';
import { useSession } from '@/ui/hooks/use-session';

export const RequireAuth = () => {
  const { eventId = '' } = useParams();
  const { isAuthenticated, session } = useSession();
  const { pathname } = useLocation();
  const isUnauthorized = !session.isPending && !isAuthenticated && !pathname.startsWith('auth');

  if (isUnauthorized) return <Navigate to='/auth' replace />;

  if (isAuthenticated && eventId) {
    return (
      <PageRequireAuth>
        <Outlet />
      </PageRequireAuth>
    );
  }

  return <Outlet />;
};
